import { Platform } from 'react-native';
import Config from '@bonanza-social/toolkit/config';

export type RegVariant = '11Step' | '3Step';
export enum RegistrationVariantEnum {
  elevenStep = '11Step',
  threeStep = '3Step',
}
const COOKIE_NAME = 'reg_form_variant';

const PERCENT = (() => {
  const raw = Config.NEXT_PUBLIC_REGISTRATION_THREE_STEP_PERCENT || '10';
  const n = raw ? Number(raw) : 10;
  return Math.min(Math.max(isFinite(n) ? n : 10, 0), 100);
})();

function setCookie(name: string, value: string, days = 30) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}

function getCookie(name: string): string | null {
  const matched = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return matched ? decodeURIComponent(matched[1]) : null;
}

function pickByPercent(): RegVariant {
  return Math.random() * 100 < PERCENT
    ? RegistrationVariantEnum.threeStep
    : RegistrationVariantEnum.elevenStep;
}

export function getOrAssignRegVariantWeb(): RegVariant {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const fromCookie = getCookie(COOKIE_NAME);
    if (
      fromCookie === RegistrationVariantEnum.threeStep ||
      fromCookie === RegistrationVariantEnum.elevenStep
    ) {
      return fromCookie as RegVariant;
    }

    const variant = pickByPercent();
    setCookie(COOKIE_NAME, variant);

    return variant;
  }

  return RegistrationVariantEnum.elevenStep;
}

export function getOrAssignRegVariant(): RegVariant {
  return Platform.OS === 'web'
    ? getOrAssignRegVariantWeb()
    : RegistrationVariantEnum.elevenStep;
}
